<template>
  <div :class="ui.bkgdColor">
    <v-layout row class="ml-3 mt-3 mr-3">
      <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
        Permit Requests
      </v-chip>
      <v-spacer/>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">playlist_add</v-icon>
        <div v-if="getPermitsList.length === null">
          0
        </div>
        <div v-else>
          {{getPermitsList.length}}
        </div>
      </v-chip>
    </v-layout>
    <PermitsList :attachments="{editUnlock: true, attach: []}"/>
    <v-layout row class="ml-3 mt-3 mr-3">
      <v-spacer/>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">create</v-icon>
        <div v-if="getPermitsList.length === null">
          0
        </div>
        <div v-else>
          {{this.calcStatsWorkStatus("Created", this.getPermitsList)}}
        </div>
      </v-chip>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">settings</v-icon>
        <div v-if="getPermitsList.length === null">
          0
        </div>
        <div v-else>
          {{this.calcStatsWorkStatus("Progress", this.getPermitsList)}}
        </div>
      </v-chip>
      <v-chip :color="ui.chipColor" :class="ui.textSubheading">
        <v-icon left :color="ui.btnColor">check_box</v-icon>
        <div v-if="getPermitsList.length === null">
          0
        </div>
        <div v-else>
          {{this.calcStatsWorkStatus("Ready", this.getPermitsList)}}
        </div>
      </v-chip>
    </v-layout>
    <v-layout row class="mr-1 mt-4">
      <v-spacer/>
      <PermitsNew/>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import PermitsNew from "@/operations/permits/components/PermitsNew";
import PermitsList from "@/operations/permits/components/PermitsList";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";

export default {
  // eslint-disable-next-line
  mixins: [apptheme, statsFunctions],
  components: {
    PermitsList,
    PermitsNew
  },
  props: {
    attachments: {
      type: Object
    }
  },
  methods: {
    editResource() {
      // eslint-disable-next-line
      this.$store.dispatch("changeResourceListDisplay", this.list);
      this.enableEditBtn = true;
    }
  },
  computed: {
    ...mapGetters([
      "getPermitsList",
      "getPermitsListCounter",
      "getCurrentPage",
      "getWork"
    ]),
    list() {
      // eslint-disable-next-line
      if (this.getPermitsList !== undefined && this.getPermitsList.length !== 0) {
        return this.getPermitsList; // used for new attachments
      } else if (this.getPermitsList === undefined) {
        return [];
      } else if (this.getPermitsList.length !== 0) {
        return this.getPermitsList;
      } else {
        return [];
      }
    },
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableEditBtn: false
    };
  }
};
</script>
